export default __webpack_public_path__ + "static/media/MVRDV-slide-03.1e9d7d63.jpg";